import React from 'react'
import Resx from '@/components/Resx'
import { Col, Row } from 'reactstrap'
import { WhiteBox } from '@/components/Layout'
import { useLocalization } from '@/hooks/localization'

const getAlertVariant = (severity) => {
  switch (severity) {
    case 0: return 'danger'
    case 1: return 'warning'
    case 2: return 'info'
  }
}

const CheckingRulesList = ({ checkingRules, onlyShowIssues }) => {
  const { localizeValue } = useLocalization()

  if (!checkingRules || !checkingRules.length) return

  const rulesToRender = onlyShowIssues ? checkingRules.filter(x => x.lastResult < 3) : checkingRules

  return <WhiteBox header='Reporting.CheckingRuleResults'>
    <Row>
      <Col sm='12'>
        {rulesToRender.sort((a, b) => {
          if (a.lastResult < b.lastResult) return -1
          if (a.lastResult > b.lastResult) return 1
          return 0
        }).map((x, i) => {
          const variant = getAlertVariant(x.lastResult)
          return <CheckingRulesDetail key={i} variant={variant} message={localizeValue(x.message, x.latinMessage)} />
        })}
      </Col>
    </Row>
  </WhiteBox>
}
const CheckingRulesDetail = ({ message, variant }) => {
  let tree
  try {
    tree = JSON.parse(message)
  } catch (e) {
    return <div className={'chr-expression-holder chr-expression-holder-danger chr-message'}>{message}</div>
  }

  function drawIf (condition, conditionTrue, conditionFalse, level) {
    return (
      <div className={'chr-expression-if chr-expression-level-' + level}>
        <div>{renderTreeData(condition, level + 1)}</div>
        <div className={'chr-expression-binary-operand'}><span>?</span></div>
        <div>{renderTreeData(conditionTrue, level + 1)}</div>
        <div className={'chr-expression-binary-operand'}><span>:</span></div>
        <div>{renderTreeData(conditionFalse, level + 1)}</div>
      </div>
    )
  }

  function drawBinary (op, l, r, level) {
    return (
      <div className={'chr-expression-binary chr-expression-level-' + level}>
        <div>{renderTreeData(l, level + 1)}</div>
        <div className={'chr-expression-binary-operand'}><span>{op}</span></div>
        <div>{renderTreeData(r, level + 1)}</div>
      </div>
    )
  }

  function drawCell (cellData) {
    return (
      <div className={'chr-expression-cell'} title={'Report: ' + cellData.ReportName + '\nRow: ' + cellData.RowName + '\nColumn: ' + cellData.ColName}>
        <div className={'chr-expression-heading'}>Cell</div>
        <div className={'chr-expression-details'}>
          <div><Resx name={'Reporting.Report'} />: {cellData.ReportName}</div>
          <div><Resx name={'Reporting.Row'} />: {cellData.RowName}</div>
          <div><Resx name={'Reporting.Column'} />: {cellData.ColName}</div>
        </div>
      </div>
    )
  }

  function drawLiteral (val) {
    return (
      <div className={'chr-expression-literal'}>
        <div className={'chr-expression-heading'}><Resx name={'Reporting.Literal'} /></div>
        <div>{val}</div>
      </div>
    )
  }

  function renderTreeData (treeData, level) {
    switch (treeData['Type']) {
      case 'Binary':
        return drawBinary(treeData['Operand'], treeData['Left'], treeData['Right'], level)
      case 'If':
        return drawIf(treeData['Condition'], treeData['True'], treeData['False'], level)
      case 'Cell':
        return drawCell(treeData)
      case 'Literal':
        return drawLiteral(treeData['Value'])
    }
  }

  return (
    <div className={'chr-expression-holder chr-expression-holder-' + variant}>{renderTreeData(tree, 0)}</div>
  )
}

export { CheckingRulesList, CheckingRulesDetail }



// WEBPACK FOOTER //
// ./src/components/reporting/submissions/checkingRulesList.js